import { useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";

import { useGetSchoolClientsListQuery } from "store/services/clients/school.client";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { userFullName } from "helpers/common";
import TableHeader from "components/shared/FormComponents/TableHeader";
import SearchListCheckbox from "components/shared/SearchListCheckbox";
import {
    useDisciplinesLookupQuery,
    useDivisionLookupQuery,
    useGetDisciplineTagsQuery
} from "store/services/utility";
import {
    SCHOOL_CLIENT_DETAIL
} from "config/paths";
import moment from "moment";
import ClientsReportMenu from "components/shared/ReportComponents/ClientsReportMenu";
import { GRADE_OPTIONS } from "config/constants";
import TableLayout from "components/TableLayout";
import { CommonMultiSelect, CommonSelect, CstmPagination } from "components/Common/Common";
import { useCreateStrategyTemplateMutation, useGetRecommendationTemplatesQuery, useGetStartegyTemplatesQuery, useRemoveRecommendationTemplateMutation, useRemoveStrategyTemplateMutation } from "store/services/clients/reports-v2/recommendationTemplates";
import { Link } from "react-router-dom";
import RecommendationsModal from "components/Modals/RecommendationsModal";
import ConfirmationPop from "components/Modals/ConfirmationPop";
import StrategiesModal from "components/Modals/StrategiesModal";
import { useSelector } from "react-redux";

const initialFilterState = {
    search: "",
    areas: [],
    sort: {
        column: "id",
        direction: "DESC",
    },
};

const StrategiesTemplates = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [filter, setFilter] = useState(initialFilterState);
    const [recommendationsModal, setRecommendationsModal] = useState(false)
    const [currentEntry, setCurrentEntry] = useState(null)
    const [showDeleteModal, setShowDeleteModal] = useState(false)
    const therapist = useSelector((state) => state?.auth?.user)
    const disciplineId = therapist?.therapist_discipline?.id

    const { data: disciplineTags, isFetching: areasLoading } = useGetDisciplineTagsQuery(disciplineId, { skip: !disciplineId });
    const disciplineTagOptions = disciplineTags?.length > 0 ? disciplineTags?.map(area => ({ value: area.id, label: area.name })) : [];
    const { data, isLoading, isError, isFetching } = useGetStartegyTemplatesQuery({ page: currentPage, limit: pageSize, ...filter });
    const [removeTemplate, { isLoading: removeTemplateLoading }] = useRemoveStrategyTemplateMutation()

    const schoolClients = data?.records;
    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);

    const column = [
        {
            head: "Name",
            accessor: "name",
            isComponent: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-sbold">{item?.title}</h6>
            ),
        },
        // {
        //     head: "Date Created",
        //     accessor: "createdAt",
        //     isComponent: true,
        //     component: (item, ind) => (
        //         <div>{moment(item?.client_detail?.dob).format("DD/MM/YYYY")}</div>
        //     ),
        // },
        {
            head: "Date Used",
            accessor: "lastUsed",
            isComponent: true,
            component: (item, ind) => (
                <div>{moment(item?.client_detail?.dob).format("DD/MM/YYYY")}</div>
            ),
        },
        {
            head: "Tags",
            accessor: "tags",
            isComponent: true,
            component: (item, ind) => (
                <div className="d-flex area-pills flex-wrap gap-2 mt-2">
                    {item?.StrategyTemplateTagsMapping?.map((tag) => (
                        <Button
                            key={tag}
                            type="button"
                            variant={"primary"}
                            className="rounded-pill px-3 py-1"
                        >
                            {tag?.strategyTemplateTags?.name}
                        </Button>
                    ))}
                </div>
            ),
        },
        // {
        //     head: "Action",
        //     accessor: "",
        //     isComponent: true,
        //     component: (item, index) => (
        //         <ClientsReportMenu
        //             index={index}
        //             client={item}
        //         />
        //     ),
        // },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item, index) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    <Dropdown
                        onClick={(e) => e.stopPropagation()}
                    // show={index == dropdownIndex}
                    // onToggle={() => setDropdownIndex(index == dropdownIndex ? null : index)}
                    >
                        <Dropdown.Toggle
                            variant="transparent"
                            className="p-0 border-0 text-dark w-100"
                            id="dropdown-basic"
                        >
                            <span className="icn ">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="13"
                                    viewBox="0 0 28 13"
                                    fill="none"
                                >
                                    <rect width="28" height="13" rx="6.5" fill="" />
                                    <path
                                        d="M23.2678 4.73223C22.2915 3.75592 20.7085 3.75592 19.7322 4.73223C18.7559 5.70854 18.7559 7.29146 19.7322 8.26777C20.7085 9.24408 22.2915 9.24408 23.2678 8.26777C24.2441 7.2915 24.2441 5.70858 23.2678 4.73223Z"
                                        fill="#315D99"
                                    />
                                    <path
                                        d="M16.2678 4.73223C15.2915 3.75592 13.7085 3.75592 12.7322 4.73223C11.7559 5.70854 11.7559 7.29146 12.7322 8.26777C13.7085 9.24408 15.2915 9.24408 16.2678 8.26777C17.2441 7.2915 17.2441 5.70858 16.2678 4.73223"
                                        fill="#315D99"
                                    />
                                    <path
                                        d="M9.26777 4.73223C8.29146 3.75592 6.70854 3.75592 5.73223 4.73223C4.75592 5.70854 4.75592 7.29146 5.73223 8.26777C6.70854 9.24408 8.29146 9.24408 9.26777 8.26777C10.2441 7.2915 10.2441 5.70858 9.26777 4.73223"
                                        fill="#315D99"
                                    />
                                </svg>
                            </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu className="" style={{ right: 0, left: "unset" }}>
                            {
                                console.log('item', item)
                            }
                            <ul className="list-unstyled mb-0" style={{ paddingLeft: "19px" }}>
                                <h5 className="cursor-pointer proxima mb-2" onClick={() => { setCurrentEntry(item); setRecommendationsModal(true) }} style={{ borderBottom: "0.5px solid #000", padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Edit Template</h5>
                                <h5 className="cursor-pointer proxima mb-2" onClick={() => { setCurrentEntry(item); setShowDeleteModal(true) }} style={{ padding: "13px 0", fontSize: "14px", fontWeight: 500, color: "#071E3E" }}>Delete Template</h5>
                            </ul>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
            ),
        },
    ];

    const handleFilterChange = (key) => (value) => {
        setFilter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const resetFilter = () => {
        setFilter(initialFilterState);
    };

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };

    const handlePageSizeChange = (e) => {
        setPageSize(parseInt(e.target.value, 10));
        setCurrentPage(1); // Reset to first page when page size changes
    };

    const handleDelete = async () => {
        try {
            setShowDeleteModal(false);

            const result = await removeTemplate({ clientType: null, id: currentEntry?.id });
            if (result.error) return;
            successMessageToast(result?.message);

        } catch (err) { console.log("Error deleting template", err) };
    };

    return (
        <>
            {
                removeTemplateLoading && <LoadingOverlay />
            }
            <StrategiesModal
                show={recommendationsModal}
                setShow={setRecommendationsModal}
                currentEntry={currentEntry}
                disciplineTagOptions={disciplineTagOptions}
            />
            <ConfirmationPop
                confirmation={showDeleteModal}
                setConfirmation={setShowDeleteModal}
                confirmHandler={handleDelete}
                type="delete"
            />
            <section className="client position-relative py-4">
                <Container fluid>
                    {(isLoading) ? <div >  <LoadingIndicator /></div> :
                        <Row>
                            <Col lg="12" className="my-2">
                                <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                                    <div className="left">
                                        <TableHeader
                                            heading={"Strategy Templates"}
                                            filter={filter}
                                            handleFilterChange={handleFilterChange}
                                            resetFilter={resetFilter}
                                            searchPlaceholder="Template Name"
                                            filterComponent={
                                                <>
                                                    {/* <li>
                                                        <CommonSelect
                                                            placeholder={"Area"}
                                                            option={disciplineTagOptions}
                                                            onChange={handleFilterChange("areas")}
                                                            value={filter?.areas}
                                                            isFilter={true}
                                                            isMulti={true}
                                                        // isClearable
                                                        />
                                                    </li> */}
                                                    <li>
                                                        <Dropdown onSelect={(selected) => handleFilterChange("tags")([selected])}>
                                                            <Dropdown.Toggle
                                                                className={`ps-3 text-capitalize border-start rounded-0 pe-0 border-0 themeBlue d-flex align-items-center`}
                                                                variant="transparent"
                                                                id="dropdown-basic"
                                                            >
                                                                <div className="d-flex">
                                                                    <div style={{ width: "120px", overflow: "hidden", textOverflow: "ellipsis", boxSizing: "border-box" }}>
                                                                        {disciplineTagOptions.find(x => x.value == filter?.tags)?.label || "Select Tags"}
                                                                    </div>
                                                                    <span className="icn" style={{ marginRight: "20px" }}>
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="12"
                                                                            height="8"
                                                                            viewBox="0 0 12 8"
                                                                            fill="none"
                                                                        >
                                                                            <path
                                                                                d="M1.415 0.298828L6 4.731L10.585 0.298828L12 1.66666L6 7.46666L0 1.66666L1.415 0.298828Z"
                                                                                fill="black"
                                                                            />
                                                                        </svg>
                                                                    </span>
                                                                </div>
                                                            </Dropdown.Toggle>

                                                            <Dropdown.Menu style={{ maxHeight: "250px", overflowY: "auto" }}                        >
                                                                {disciplineTagOptions?.length ? disciplineTagOptions?.map((item, index) => {
                                                                    return <Dropdown.Item eventKey={item?.value}>{item?.label}</Dropdown.Item>
                                                                }) : <>
                                                                    <Dropdown.Item disabled eventKey={""}>No Record Found</Dropdown.Item>

                                                                </>
                                                                }
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </li>
                                                </>
                                            }
                                        ></TableHeader>
                                    </div>
                                    <div className="right">
                                        <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                                            <li className="">
                                                <Link
                                                    to={""}
                                                    onClick={() => { setCurrentEntry(null); setRecommendationsModal(true) }}
                                                    className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                                                >
                                                    <span className="icn me-1">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="19"
                                                            height="19"
                                                            viewBox="0 0 19 19"
                                                            fill="none"
                                                        >
                                                            <mask
                                                                id="mask0_0_4440"
                                                                style={{ maskType: "alpha" }}
                                                                maskUnits="userSpaceOnUse"
                                                                x="0"
                                                                y="0"
                                                                width="19"
                                                                height="19"
                                                            >
                                                                <rect
                                                                    width="18.7197"
                                                                    height="18.7197"
                                                                    fill="#D9D9D9"
                                                                />
                                                            </mask>
                                                            <g mask="url(#mask0_0_4440)">
                                                                <path
                                                                    d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                                    fill="white"
                                                                />
                                                            </g>
                                                        </svg>
                                                    </span>{" "}
                                                    Create New
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </Col>
                            <Col lg="12" className="my-3">
                                <div className="table-outer">
                                    {isError ? (
                                        <ErrorComponent />
                                    ) : (
                                        <>
                                            {isFetching && <LoadingOverlay />}
                                            <TableLayout
                                                data={schoolClients}
                                                column={column}
                                            // url={SCHOOL_CLIENT_DETAIL.replace("/:id", "")}
                                            // url={"/manage-team/therapist-profiles/detail/"}
                                            />
                                        </>
                                    )}
                                    <CstmPagination
                                        totalPages={totalPages}
                                        activePage={currentPage}
                                        handlePageChange={handlePageChange}
                                    />
                                </div></Col>
                        </Row>}
                </Container>
            </section>
        </>
    );
};

export default StrategiesTemplates;



